import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.Comparison__V1_AddToComparison];

export const getQueryKey = (): QueryKey => [EQueryKeys.Comparison__V1_AddToComparison];
